module.exports = __webpack_public_path__ + "images/stickers/taco-sleeping.42698e61c8b85ce46dd0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-sleeping.png
// module id = cC2i
// module chunks = 12